import { Box, Skeleton, Stack } from '@mui/material';

const CardSkeleton = ({ rows = 3 }) => (
	<div className="bg-[#f3f5f5] rounded-[12px] p-4 flex flex-col justify-between min-h-[280px]">
		<div>
			<Skeleton variant="text" sx={{ fontSize: '10px', width: '130px', mb: 0.5 }} />
			<Skeleton variant="text" sx={{ fontSize: '2rem', width: '170px', mb: 1 }} />
			<Skeleton variant="rectangular" sx={{ width: '100%', height: '48px', borderRadius: '10px', mb: 0.5 }} />
			{Array.from({ length: rows }).map((_, i) => (
				<div key={i} className="flex items-center justify-between py-3 border-t border-gray-200">
					<Skeleton variant="text" sx={{ fontSize: '10px', width: '110px' }} />
					<Skeleton variant="text" sx={{ fontSize: '10px', width: '75px' }} />
				</div>
			))}
		</div>
		<div className="flex justify-end mt-2">
			<Skeleton variant="rounded" sx={{ width: '120px', height: '40px', borderRadius: '9999px' }} />
		</div>
	</div>
);

const OpportunitySkeleton = () => (
	<div>
		<Skeleton variant="text" sx={{ fontSize: '14px', width: '70%', bgcolor: 'rgba(255,255,255,0.12)' }} />
		<div className="flex items-center justify-between mt-2">
			<div className="flex flex-col gap-1">
				<Skeleton variant="text" sx={{ fontSize: '12px', width: '100px', bgcolor: 'rgba(255,255,255,0.12)' }} />
				<Skeleton variant="text" sx={{ fontSize: '12px', width: '100px', bgcolor: 'rgba(255,255,255,0.12)' }} />
				<Skeleton variant="rounded" sx={{ width: '72px', height: '28px', borderRadius: '9999px', mt: 0.5, bgcolor: 'rgba(255,255,255,0.12)' }} />
			</div>
			<Skeleton variant="circular" sx={{ width: '80px', height: '80px', bgcolor: 'rgba(255,255,255,0.12)' }} />
		</div>
	</div>
);

export const SummaryLoader = () => (
	<Stack gap={1.5}>
		{/* Top row — 3 summary cards */}
		<div className="grid grid-cols-1 md:grid-cols-3 gap-3">
			<CardSkeleton rows={3} />
			<CardSkeleton rows={4} />
			<CardSkeleton rows={3} />
		</div>

		{/* Middle row — chart + latest opportunities */}
		<div className="grid grid-cols-1 md:grid-cols-3 gap-3">
			{/* Repayment chart — spans 2 cols */}
			<div className="md:col-span-2 bg-[#f3f5f5] rounded-[12px] p-6">
				<div className="flex items-center justify-between mb-4">
					<Skeleton variant="text" sx={{ fontSize: '14px', width: '160px' }} />
					<div className="flex gap-2">
						<Skeleton variant="rounded" sx={{ width: '80px', height: '26px', borderRadius: '9999px' }} />
						<Skeleton variant="rounded" sx={{ width: '80px', height: '26px', borderRadius: '9999px' }} />
					</div>
				</div>
				<div className="flex items-end gap-3 h-[280px] px-2">
					{[80, 120, 60, 180, 100, 200, 140, 90, 160, 110].map((h, i) => (
						<Skeleton key={i} variant="rectangular" sx={{ flex: 1, height: `${h}px`, borderRadius: '4px' }} />
					))}
				</div>
			</div>

			{/* Latest opportunities — dark bg */}
			<div className="bg-investor-bg rounded-[16px] p-6 flex flex-col gap-4">
				<Skeleton variant="text" sx={{ fontSize: '16px', width: '160px', bgcolor: 'rgba(255,255,255,0.15)' }} />
				<hr className="border-t border-investor-divider" />
				<OpportunitySkeleton />
				<hr className="border-t border-investor-divider" />
				<OpportunitySkeleton />
			</div>
		</div>

		{/* Bottom row — 6 quick-action tiles */}
		<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3">
			{[false, false, false, false, true, true].map((green, i) => (
				<div
					key={i}
					className={`${green ? 'bg-investor-green' : 'bg-investor-bg'} rounded-[12px] p-4 min-h-[120px] flex flex-col`}>
					<Skeleton
						variant="circular"
						sx={{ width: '36px', height: '36px', alignSelf: 'flex-end', bgcolor: green ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.12)' }} />
					<Box sx={{ mt: 'auto' }}>
						<Skeleton
							variant="text"
							sx={{ fontSize: '12px', width: '80%', bgcolor: green ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.12)' }} />
						<Skeleton
							variant="text"
							sx={{ fontSize: '12px', width: '55%', bgcolor: green ? 'rgba(255,255,255,0.3)' : 'rgba(255,255,255,0.12)' }} />
					</Box>
				</div>
			))}
		</div>
	</Stack>
);
